"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getIdahoRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _types = require("../../assets/types");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'ID';

function getIdahoRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), (0, _commonRules.thriftSavingsPlans)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Motor Vehicles',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (3)',
    limitAggregateSingle: 7000,
    limitAggregateJoint: 14000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Books, Family Pictures, Heirlooms, Household Goods, Musical Instruments,' + ' Collectibles of value, Clothes, Animals',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (1)',
    limitAggregateSingle: 7500,
    limitAggregateJoint: 15000,
    // NOTE: The norm is that lawyers list all household goods together, not itemized even though that's the statute.
    // limitPerItem: 750,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.HOUSEHOLD, _subTypes.BOOK, _subTypes.ANTIQUE, _subTypes.ARTWORK, _subTypes.COLLECTIBLES, _subTypes.CLOTHES, _subTypes.FAMILY_PHOTOS, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT, _subTypes.PERSONAL_ANIMALS, _subTypes.CROPS, _subTypes.ELECTRONICS];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Aids',
    type: stateCode,
    statuteName: 'Idaho Code § 11-603 (2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Veterans\' Benefit',
    type: stateCode,
    statuteName: 'Idaho Code § 11-603 (3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security',
    type: stateCode,
    statuteName: 'Idaho Code § 11-603 (3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiarytype = _lodash["default"].get(asset, 'assetJSON.tertiarytype');

      return this.canTakeMoreExemptions() && tertiarytype === _tertiaryTypes.SOCIAL_SECURITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Earned Income Tax Credit (except child and education tax credit)',
    type: stateCode,
    statuteName: 'Idaho Code § 11-603 (4)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.INCOME_TAX_CREDIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Federal, State and Local Public Assistance',
    type: stateCode,
    statuteName: 'Idaho Code § 11-603 (4)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Medical Benefits Amount in Medical savings account',
    type: stateCode,
    statuteName: 'Idaho Code § 11-603 (5); Idaho Code § 63-3022K',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTH_SAVINGS_ACCOUNT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'Idaho Code § 11-603 (6)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability benefits',
    type: stateCode,
    statuteName: 'Idaho Code § 11-604 (1)(a); Idaho Code § 41-1834',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS || tertiaryType === _tertiaryTypes.DEATH_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony, Child Support',
    type: stateCode,
    requiresReview: true,
    statuteName: 'Idaho Code § 11-604 (1)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful Death Recoveries',
    type: stateCode,
    statuteName: 'Idaho Code § 11-604 (1)(c)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.WRONGFUL_DEATH_AWARD];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Recovery',
    type: stateCode,
    statuteName: 'Idaho Code § 11-604 (1)(c)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (Beneficiary other the the Insured)',
    type: stateCode,
    requiresReview: true,
    statuteName: 'Idaho Code § 11-604 (d); Idaho Code § 41-1833',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Pensions and other Retirement Plans',
    type: stateCode,
    statuteName: 'Idaho Code § 11-604A',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.PENSION_PLAN || tertiaryType === _tertiaryTypes.ROTH_IRA || subType === _subTypes.OTHER_RETIREMENT_PLAN || subType === _subTypes.RETIREMENT_PLAN || tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN);
    }
  }, {
    id: idCounter.increment(),
    description: 'College Savings Account',
    type: stateCode,
    statuteName: 'Idaho Code § 11-604A (4)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.COLLEGE_SAVINGS_ACCOUNT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unpaid Wages - 75% or 30 times federal hourly, limit is per calendar year',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (11); Idaho Code § 11-207',
    limitAggregateSingle: 1500,
    limitAggregateJoint: 3000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.UNPAID_WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Jewelry',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (2)',
    limitAggregateSingle: 1000,
    limitAggregateJoint: 2000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.JEWELRY, _subTypes.WATCH, _subTypes.WEDDING_RINGS];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Office equipment, furnishings, and supplies. Implements, Books and Tools of Trade',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (3)',
    limitAggregateSingle: 2500,
    limitAggregateJoint: 5000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.OFFICE_EQUIPMENT || subType === _subTypes.TOOLS_OF_TRADE);
    }
  }, {
    id: idCounter.increment(),
    description: 'Food, Water and Storage - for 12 months',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (4)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FOOD_AND_FUEL;
    }
  }, {
    id: idCounter.increment(),
    description: 'Arms, Uniforms and Accoutrements for Peace Officers',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (6)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.UNIFORMS || subType === _subTypes.MILITARY_EQUIPMENT);
    }
  }, {
    id: idCounter.increment(),
    description: 'Crops on 50 acres',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (7)',
    limitAggregateSingle: 1000,
    limitAggregateJoint: 2000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CROPS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Water Rights to 160 inches of water',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (7)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WATER_RIGHTS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Firearms',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (8)',
    limitAggregateSingle: 750,
    limitAggregateJoint: 1500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FIREARMS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unmatured Life Insurance (other than credit life insurance)',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (9)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Buildings',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (5)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.BUSINESS_PROPERTY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Proceeds for Damaged exempt property',
    type: stateCode,
    statuteName: 'Idaho Code § 11-606',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.DAMAGED_PROPERTY_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Liquor Permit',
    type: stateCode,
    statuteName: 'Idaho Code § 23-514',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.LIQUOR_PERMIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Group Life Insurance Benefits',
    type: stateCode,
    statuteName: 'Idaho Code § 41-1835',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.GROUP_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Annuity Proceeds - to $1,250 per month',
    type: stateCode,
    requiresReview: true,
    statuteName: 'Idaho Code § 41-1836',
    limitAggregateSingle: 1250,
    limitAggregateJoint: 2500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.ANNUITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (if Clause Prohibits)',
    type: stateCode,
    statuteName: 'Idaho Code § 41-1930',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Society Benefits',
    type: stateCode,
    statuteName: 'Idaho Code § 41-3218',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Building Materials',
    type: stateCode,
    statuteName: 'Idaho Code § 45-514',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Police Officer Retirement',
    type: stateCode,
    statuteName: 'Idaho Code § 50-1517',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.POLICE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Partnership Property',
    type: stateCode,
    statuteName: 'Idaho Code § 53-3-307',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.PARTNERSHIP_PROPERTY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Homeowners\' Insurance Proceeds',
    type: stateCode,
    statuteName: 'Idaho Code § 55-1008',
    limitAggregateSingle: 100000,
    limitAggregateJoint: 200000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.HOMEOWNERS_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA Benefits',
    type: stateCode,
    statuteName: 'Idaho Code § 55-1011',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Aid for Blind and Disabled',
    type: stateCode,
    statuteName: 'Idaho Code § 56-223',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.AID_TO_BLIND;
    }
  }, {
    id: idCounter.increment(),
    description: 'General Assistance',
    type: stateCode,
    statuteName: 'Idaho Code § 56-223',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employee Retirement',
    type: stateCode,
    statuteName: 'Idaho Code § 59-1317',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.PUBLIC_EMPLOYEE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: "Crime Victims' Compensation",
    type: stateCode,
    statuteName: 'Idaho Code § 72-1020',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Firefighter Retirement',
    type: stateCode,
    statuteName: 'Idaho Code § 72-1422',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.FIREFIGHTERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'Idaho Code § 72-802',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    type: stateCode,
    statuteName: 'Idaho Code § 11-605 (10)',
    limitAggregateSingle: 800,
    limitAggregateJoint: 1600,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validTypes = [_types.VEHICLE, _types.PERSONAL];
      var validSubTypes = [_subTypes.HOUSEHOLD, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT, _subTypes.INVENTORY, _subTypes.FARM_ANIMALS, _subTypes.FARMING_EQUIPMENT, _subTypes.FARMING_SUPPLIES, _subTypes.FARMING_PROPERTY, _subTypes.FISHING_SUPPLIES, _subTypes.FISHING_PROPERTY];
      return this.canTakeMoreExemptions() && (validTypes.includes(type) || validSubTypes.includes(subType) || type === _types.BUSINESS && subType === _subTypes.OTHER);
    }
  }];
}